import { Link } from "react-router-dom";
import { formatPrice, productImg } from "@/lib/api";

export function ProductCard({ product }) {
  const minPrice = Math.min(...product.variants.map((v) => v.price));
  const hasRange = product.variants.length > 1;

  return (
    <Link
      to={`/product/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="group block overflow-hidden rounded-2xl border border-brand-line bg-white transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_8px_30px_rgba(212,175,55,0.18)]"
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-cream">
        <img
          src={productImg(product)}
          alt={product.name}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        {product.bestseller && (
          <span className="absolute left-3 top-3 rounded-full bg-brand-gold px-3 py-1 text-xs font-semibold uppercase tracking-wide text-brand-dark">
            Top Selling
          </span>
        )}
        {product.customizable && (
          <span className="absolute right-3 top-3 rounded-full bg-brand px-3 py-1 text-xs font-semibold text-white">
            Customisable
          </span>
        )}
      </div>
      <div className="p-5 text-center">
        <h3 className="font-heading text-xl text-brand-dark">{product.name}</h3>
        <p className="mt-2 text-lg font-semibold text-brand">
          {hasRange ? "From " : ""}
          {formatPrice(minPrice)}
        </p>
      </div>
    </Link>
  );
}
